<template>
  <div v-if="bannerList.length > 0">

    <!--    <div class="zAsCjLdh1d8SdqBcjnJY">-->
    <div  class="rndx react-draggable"
          style="position: fixed; user-select: auto; width: 36px; height: 36px; display: inline-block; top: 65%; right: 3px; z-index: 4 ;  max-width: 9.0072e+15px; max-height: 9.0072e+15px; ">
      <img  @click="$parent.goNav('/hongbao')" class="icon" src="/static/image/red-packet.png">
      <div></div>
    </div>

    <div style="position: relative">
      <van-swipe @change="onChange" :show-indicators="false" style="height: 270px">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img
              :src="item.src"
              style="width: 100%; height: 100%; object-fit: cover"
              alt=""
          />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 公告 -->
    <div style="background-color: #f4f6ff; " v-if="homenoticelis.length > 0">
      <div class="gonggao"  @click="$parent.goNav('')" >
        <svg style="width: 20px;height: 20px;" xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="none" viewBox="0 0 21 21">
          <path fill="url(#ic-home-notice_svg__a)" d="M9.12 4.57 5.689 6.486a.75.75 0 0 1-.439.139H1.5a1.5 1.5 0 0 0-1.5 1.5v6.75a1.5 1.5 0 0 0 1.5 1.5h3.75a.75.75 0 0 1 .435.139l3.431 1.916a1.5 1.5 0 0 0 2.374-1.219V5.79A1.5 1.5 0 0 0 9.12 4.57m7.598 14.636a.75.75 0 0 1-.447-1.354 7.875 7.875 0 0 0 0-12.704.751.751 0 1 1 .889-1.212 9.375 9.375 0 0 1 0 15.128.75.75 0 0 1-.442.142"></path>
          <path fill="url(#ic-home-notice_svg__b)" d="M14.591 15.101a.75.75 0 0 1-.543-1.264 4.875 4.875 0 0 0 0-6.674.752.752 0 0 1 1.09-1.032 6.375 6.375 0 0 1 0 8.738.75.75 0 0 1-.547.232"></path>
          <defs><linearGradient id="ic-home-notice_svg__a" x1="10.498" x2="10.498" y1="3.791" y2="19.206" gradientUnits="userSpaceOnUse">
            <stop stop-color="#B17AE0"></stop>
            <stop offset="1" stop-color="#C1C4F2"></stop>
          </linearGradient><linearGradient id="ic-home-notice_svg__b" x1="15.357" x2="15.357" y1="5.896" y2="15.101" gradientUnits="userSpaceOnUse">
            <stop stop-color="#B17AE0"></stop><stop offset="1" stop-color="#C1C4F2"></stop></linearGradient></defs></svg>
        <div style="flex: 1">
          <van-notice-bar color="#5d75a2" background="#f4f6ff" scrollable
          ><span v-for="(item, index) in homenoticelis" :key="index" @click="openGogao(item)" style="color: #9e9e9e">{{ item }}</span></van-notice-bar
          >
        </div>
      </div>
    </div>
    <!-- 公告 -->
    <div class="domainModal_domainView__FWCzg" v-if="goInfo">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">

        <img src="/static/image/hongbaocolse.png"
             alt="关闭"
             style="
           position: absolute;
           top: 5px;
           right: 13px;
           width: 0.7rem;
         "
             @click="goInfo = null" />

        <div class="domainModal_middle__3gQPm" style="padding: 35px 10px 15px">
          {{ goInfo }}

          <van-button
              type="info"
              style="
          display: block;              /* 新增居中属性 */
          background-color: #935d94;
          border: 1px solid #935d94;
          width: 120px;
          height: 35px;
          margin: 20px auto 0;        /* 合并外边距属性 */
          border-radius: 10px;
        "
              @click="$parent.goNav('/message')">
            更多公告
          </van-button>
        </div>
      </div>
    </div>
    <!-- 用户信息栏 -->
    <div class="xiding">
      <div class="caosuo">
        <div class="lefsg" v-if="$store.state.token">
          <div class="name" style="display: flex;" >
            <span class="responsive-ellipsis">{{ $store.state.userInfo.username }}</span>
            <!--            <span class="vip">-->
            <!--            asndqwdksqwq-->
            <svg xmlns="http://www.w3.org/2000/svg" style="width: 40px;height: 20px;margin-left: 7px;" viewBox="0 0 36 12.001"><defs><linearGradient id="0_svg__a" x1="0.145" x2="0.217" y1="0.279" y2="-0.285" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#7272ff"></stop><stop offset="1" stop-color="#c477c4"></stop></linearGradient></defs><path fill="url(#0_svg__a)" d="M3476.051 766.121a5.144 5.144 0 1 0 0 10.286h23.708a5.144 5.144 0 1 0 0-10.286zm0-.857h23.708a6 6 0 1 1 0 12h-23.708a6 6 0 1 1 0-12" transform="translate(-3469.905 -765.264)"></path><g fill="url(#0_svg__a)" transform="translate(-3470.905 -765.264)"><path d="M3483.013 768.28h-.059l-.505 1.032-.416.848-.663 1.353-.324.661-.117-.661-.39-2.2-.183-1.032h-1.451l.183 1.032.053.3.337 1.9.183 1.032.3 1.72h1.5l.309-.614.542-1.106.506-1.032 1.078-2.2.5-1.032ZM3485.381 768.28l-.146 1.032-.312 2.2-.146 1.032-.242 1.72h1.382l.243-1.72.146-1.032.311-2.2.146-1.032Z"></path><path d="M3490.722 772.552a3 3 0 0 0 .444-.008h-.691q.124.001.247.008" opacity="0.7" style="isolation: isolate;"></path><path d="M3493 769.466c-.025-.052-.053-.1-.082-.154a2.2 2.2 0 0 0-1.5-1.032h-3.032l-.046.327-.1.705-.249 1.765-.062.436-.144 1.008v.023l-.241 1.72h1.45l.007-.045.236-1.674v-.023h1.887a2.1 2.1 0 0 0 .721-.126l.014-.006.049-.019a2.04 2.04 0 0 0 .985-.857 2.5 2.5 0 0 0 .251-.594 2.07 2.07 0 0 0-.144-1.454m-2.451-.169a1.12 1.12 0 0 1 .908.477v.006a1.1 1.1 0 0 1 .188.606v.123a1.056 1.056 0 0 1-1.05.935h-1.207l.3-2.134v-.01h.861Z"></path></g>
              <text fill="#7272ff" font-family="REEJI-PinboGB-Flash" font-size="8.4" transform="translate(23 9)">
                <tspan x="0" y="0" style="font-weight: bold;font-style: italic;">{{ $store.state.userInfo.current_vip_number }}</tspan>
              </text>
            </svg>
            <!--            </span>-->
            <img style="width: 17px;margin-left: 3px;margin-right: 3px;" src="@/assets/message.0ee8.png"  />





          </div>
          <div class="mey"><span>￥</span>{{ $store.state.userInfo.balance }}</div>
        </div>
        <div v-else class="lefsg" @click="$parent.goNav('/login')">
          <div class="name">未登录</div>
          <div class="mey">登录后查看</div>
        </div>
        <div class="riggs">
          <div class="lisImg" @click="$parent.goNav('/recharge')" style="color: #b1b1b1">
            <img src="@/assets/ic-home-cunkuan.b71e.png" alt="" />
            充值
          </div>
          <div class="lisImg" @click="$parent.goNav('/withdrawal')" style="color: #b1b1b1">
            <img src="@/assets/ic-home-tixian.7e5e.png" alt="" />
            提款
          </div>
          <div class="lisImg" @click="$parent.goNav('/transfer')" style="color: #b1b1b1">
            <img src="@/assets/ic-home-zhuanzhang.f739.png" alt="" />
            转账
          </div>
          <div class="lisImg"  @click="$parent.openKefu" style="color: #b1b1b1">
            <img src="@/assets/ic-home-huiyuan.f3b0.png" alt="" />
            客服
          </div>
          <!--          <div class="lisImg" @click="$parent.goNav('/vip')" style="color: #b1b1b1">-->
          <!--            <img src="/static/style/feature_vip.16d90880db727a342209f4439a9b3a12.png" alt="" />-->
          <!--            VIP-->
          <!--          </div>-->
        </div>
      </div>
    </div>


    <!-- 游戏栏 -->
    <div class="gameBoxs">

      <div class="lfst">

        <div  v-for="(item, index) in homeGameList" :key="index"
              :class="gameType == index ? 'ls active' : 'ls'"  @click="scrollToSection(index)">
          <img :src="`/static/style/${gameType == index ? item.icon_active : item.icon}.png`" alt="" />
          <span>{{ item.name }}</span>
        </div>

      </div>

      <div class="rigts"  ref="content" @scroll="handleScroll" style="padding-bottom: 100px;">
        <div
            v-for="(itemee, indexee) in homeGameList"
            :key="indexee"
            :id="'section-' + indexee"

        >
          <!--          <span  v-for="(item, index) in itemee.ddlist" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" >{{item.name}}-{{item.platform_name}}-{{item.game_code}}</span>-->
          <img  class="" v-for="(item, index) in itemee.ddlist" :key="index" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" :src="item.mobile_img" alt="" />
        </div>
      </div>
    </div>



    <!-- 弹出层 -->
    <van-popup v-model="leftshow" position="left" :style="{ height: '100%' }">
      <div class="leftbox">
        <div class="side__main__1NhyG">
          <h3>Hi，欢迎进入{{ $store.state.appInfo.title }}</h3>
          <dl class="side__vip__1dW8w">
            <div class="topxs">专属VIP体验</div>
            <p>立享会员特权</p>
            <p>享受只属于你的与众不同</p>
            <dd @click="$parent.goNav('/vip')">会员中心</dd>
          </dl>
          <ul>
            <li v-if="$store.state.token" @click="$parent.goNav('/message')"><img src="/static/image/meunIcon.39f38dc98ad956615952d485d0e6af04.svg" />消息中心<span class="side__subtitle__3QtYC"></span></li>
            <li @click="$parent.openKefu"><img src="/static/image/meunIcon2.5d0d78496889fb8b027f603254286fdf.svg" />意见反馈<span class="side__subtitle__3QtYC"></span></li>
            <li @click="doCopy($store.state.appInfo.h5_url)">
              <img src="/static/image/menuIcon5.5687ef4d1512d53aa3535e3b1088fe70.png" />永久域名<span class="side__subtitle__3QtYC">{{ $store.state.appInfo.h5_url }}</span>
            </li>
            <li @click="$parent.goNav('/abouts')"><img src="/static/image/meunIcon3.c51bbb9ebece978f1976397ab12acba7.svg" />关于我们<span class="side__subtitle__3QtYC"></span></li>
          </ul>
          <div class="nisd" v-if="!$store.state.token" @click="$parent.goNav('/login')">立即登录</div>
          <div class="nisd" v-else @click="$parent.outLogin"><img src="/static/image/tuichu.93c1b9e3d4b4a7772481916ca32c074f.svg" />安全退出</div>
        </div>
      </div>
    </van-popup>

    <!-- 官网弹窗 -->
    <div class="domainModal_domainView__FWCzg" v-if="showPopup">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="showPopup = false"></div>
      <div class="domainModal_content__1nBgc" style="width: 90%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="showPopup = false" style="position: absolute; top: 5px; right: 13px; width: 1.4rem" alt="" />
          <div class="domainModal_top__1omYS">欢迎来到{{ $store.state.appInfo.title }}</div>
          <div class="domainModal_middle__3gQPm" v-html="$store.state.appInfo.webcontent"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'index',
  data() {
    return {

      menuItems: ["首页", "关于我们", "服务", "联系我们"],
      activeIndex: 0, // 当前激活的菜单索引

      showPopup:false,


      hongbashow: true,
      appShow: true,
      current: 0,
      bannerList: [],
      homenoticelis: [],
      // 弹出层
      leftshow: false,
      activeKey: 0,
      gameType: 0,
      tanshow: true,
      appshow: true,
      goInfo: null,



      homeGameList:[],
    };
  },
  created() {

    let sessionCat = sessionStorage.getItem('home_tanshow');
    if(sessionCat || sessionCat){

    }
    sessionStorage.setItem('home_tanshow', 1);


    let that = this;
    that.gethomeGameList();
    that.getBanList();
    that.homenotice(); //获取公告




  },
  methods: {
    gethomeGameList() {
      let that = this;

      that.$apiFun.get('/api/game/catelist', { category: '' }).then(res => {
        if (res.code == 200) {
          this.homeGameList = res.data;


        }
      });
    },



// 滚动事件处理函数
    handleScroll() {
      const content = this.$refs.content;
      const sections = this.homeGameList.map((_, index) => document.getElementById(`section-${index}`));
      console.log('sections',sections)
      for (let i = sections.length - 1; i >= 0; i--) {
        const rect = sections[i].getBoundingClientRect();
        console.log(i,'rect',rect.top,rect)

        if (rect.top <= 500) { // 判断是否进入视口范围
          // this.activeIndex = i;
          this.gameType = i;
          break;
        }
      }
    },

    // 点击菜单跳转到对应内容区块
    scrollToSection(index) {
      const target = document.getElementById(`section-${index}`);
      console.log('target',target.offsetTop)
      this.$refs.content.scrollTo({
        top: target.offsetTop - 400,
        // top: 500,
        behavior: "smooth",
      });
    },
// 防抖函数
    debounce(func, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    },







    openGogao(val) {
      this.goInfo = val;
    },
    changtanshow() {
      this.tanshow = !this.tanshow;
    },
    changGameType(type) {
      this.gameType = type;
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    changleftshow() {
      this.leftshow = !this.leftshow;
    },
    getBanList() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
          .post('/api/bannerList', { type: 2 })
          .then(res => {
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.bannerList = res.data;
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
          that.ok = true;
        }
      });
    },
    onChange(index) {
      this.current = index;
    },
    changhongbashow() {
      this.hongbashow = false;
    },
    changappShow() {
      this.appShow = false;
    },
  },
  //
  // watch: {
  //   '$route'(to, from) {
  //     if(from.name == 'index' || from.name == 'activity'  || from.name == 'zhongjian'  || from.name == 'mine'  || from.name == 'index' ){
  //       document.documentElement.style.fontSize = '20px'
  //     } else {
  //       document.documentElement.style.fontSize = '40px'
  //     }
  //
  //
  //
  //   }
  // },
  mounted() {
    const lastPopupTime = localStorage.getItem('lastPopupTime');
    const currentTime = new Date().getTime();
    const oneHourInMs = 60*60*1000;

    if (!lastPopupTime || currentTime - lastPopupTime > oneHourInMs) {
      this.showPopup = true;
      localStorage.setItem('lastPopupTime', currentTime);
    }


// 添加防抖以优化滚动性能
    this.handleScroll = this.debounce(this.handleScroll, 100);
    // // 保存原始字体大小
    // this.originalFontSize = document.documentElement.style.fontSize
    //
    // // 设置当前页面特定的 rem 基准值 (例如 20px = 1rem)
    // document.documentElement.style.fontSize = '20px'
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import '/style.css';

html{
  font-size: 18px;
}
body{
  font-size: 18px;
}
// 轮播样式
.swiper-dots {
  display: flex;
  position: absolute;
  left: 40px;
  bottom: 10px;
  width: 48px;
  height: 24px;
  background-image: url(data:image/png;base64,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);
  background-size: 100% 100%;
}
.swiper-dots .num {
  width: 24px;
  height: 24px;
  border-radius: 50px;
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 24px;
}
.swiper-dots .sign {
  position: absolute;
  top: 0;
  left: 50%;
  line-height: 24px;
  font-size: 8px;
  color: #fff;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
// 主页头部标题

.homeHeder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  box-sizing: border-box;
  padding: 0 30px;
  z-index: 999;
  align-items: center;
  justify-content: space-between;
  .leftImg {
    width: 19px;
    height: 19px;
  }
  .rbox {
    display: flex;
    height: 100%;
    align-items: center;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, sans-serif;
    img {
      width: 32px;
      height: 32px;
    }
  }
}
.leftbox {
  width: 7.5rem;
  height: 100%;
  background-color: #f4f6ff;
  color: #935d94;
  .side__main__1NhyG {
    box-sizing: border-box;
    padding: 0 20px;
    h3 {
      font-size: 18px;
      font-weight: 400;
      margin: 0;
      padding-top: 72px;
    }
    .side__vip__1dW8w {
      background: url(/static/style/sidebr_vip_card.1ce7485811699286f87aae1827de7acf.png) no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      position: relative;
      p {
        color: hsla(0, 0%, 100%, 0.6);
        font-size: 12px;
        margin: 5px 0 0 0;
      }
      .topxs {
        font-size: 18px;
      }
      dd {
        float: right;
        border: 0.02rem solid #fff;
        border-radius: 0.24rem;
        height: 0.48rem;
        line-height: 0.48rem;
        width: 1.88rem;
        text-align: center;
        font-size: 10px;
        position: absolute;
        top: 20px;
        right: 20px;
      }
    }
  }
  ul {
    list-style: none;
    margin-top: 0.36rem;
    li {
      display: block;
      line-height: 0.96rem;
      height: 0.96rem;
      border-bottom: 0.02rem solid #e6ebf6;
      color: #935d94;
      font-size: 0.28rem;
      padding: 0 0.14rem;
      img {
        width: 0.36rem;
        vertical-align: middle;
        margin: -0.04rem 0.24rem 0 0;
      }
      span {
        float: right;
      }
    }
  }
  .nisd {
    position: absolute;
    width: 4.72rem;
    height: 0.8rem;
    line-height: 0.8rem;
    left: 0.9rem;
    bottom: 1rem;
    background: #dfe5ff;
    border-radius: 0.4rem;
    border: 0;
    color: #935d94;
    font-size: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      vertical-align: middle;
      margin: -0.04rem 0.08rem 0 -0.08rem;
      width: 0.32rem;
    }
  }
}
.gonggao {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.caosuo {
  color: #935d94;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .lefsg {
    flex: 1;
    .name {
      font-size: 14px;
      color: #000;
    }
    .mey {
      color: #5a4c5b;
      margin-top: 3px;
      font-size: 18px;
      font-weight: 700;
      span {
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
  .riggs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lisImg {
      width: 50px;
      text-align: center;
      font-size: 12px;
      img {
        width: 70%;
        display: block;
        margin: 0 auto;
      }
    }
  }
}
.xiding {
  background-color: #f4f6ff;
  padding: 6px 0;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

// 游戏
.gameBoxs {
  background: #edf1ff;
  box-sizing: border-box;
  padding: 10px;
  color: #935d94;
  height: 518px;
  height: calc(100vh - 40vh);

  display: flex;
  justify-content: space-between;
  .lfst {
    width: 60px;
    height: 518px;
    height: calc(100vh - 40vh);
    //background: #eff3ff;
    //border-radius: 20px;
    //border: 1px solid #fff;
    .ls.active {
      color: #5a4c5b;
      background-image: url("/static/home1.png");
      background-repeat: no-repeat;
      //background: #557af2;
    }
    .ls {
      color: #5a4c5b;
      background-image: url("/static/home0.png");
      background-repeat: no-repeat;
      //padding-bottom: 8px;
      text-align: center;
      border-radius: 20px;
      margin-bottom: 8px;
      padding: 3px 0px 8px 0px;
      img {
        //width: 30px;
        //display: block;
        //height: 25px;
        //
        //margin: 0 auto;
        //margin-top: 3px;

        width: 30px;
        display: block;
        height: 30px;
        margin: 0 auto;
        margin-top: 0px;




      }
      span {
        font-size: 12px;
        display: block;
      }
    }
  }
  .rigts {
    flex: 1;
    overflow: auto;
    height: 518px;
    height: calc(100vh - 40vh);
    box-sizing: border-box;
    padding: 0px  0px  0px 0px ;
    //display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    img {
      max-height: 150px;
      width: 100%;
      border-radius: 10px;
      margin-bottom: 0px;
    }
  }
  .rigtss {
    //flex: 1;
    //overflow: auto;
    //height: 420px;
    //box-sizing: border-box;
    //padding: 0px  0px  0px 12px ;
    //display: flex;
    //flex-wrap: wrap;
    //justify-content: space-between;
    img {
      max-height: 150px;
      width: 100%;
      border-radius: 10px;
      margin-bottom: 0px;
    }
  }
}

// app下载
.appbox {
  background-size: 100% 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.8rem;
  box-sizing: border-box;
  padding-right: 15px;
  .colse {
    width: 0.4rem;
    margin-left: 0.1rem;
  }
  .logo {
    width: 1rem;
    margin: 0 0.2rem;
  }
  .testz {
    flex: 1;
    .tit {
      font-size: 0.23rem;
      font-weight: 700;
    }
    .cx {
      font-size: 0.2rem;
      color: #ccc;
    }
  }
}
.domainModal_domainView__FWCzg {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000
}

.domainModal_domainView__FWCzg .domainModal_mask__24Y2m {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: 999;
  background-color: rgba(0,0,0,.4)
}

.domainModal_content__1nBgc {
  width: 5.96rem;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
  overflow: hidden;
  border-radius: .24rem
}

.domainModal_content__1nBgc .domainModal_contentTop__2C4jc {
  background: -webkit-gradient(linear,left top,right top,from(#6e28f1),to(#935d94));
  background: linear-gradient(90deg,#6e28f1,#935d94);
  position: relative
}

.domainModal_content__1nBgc .domainModal_shareImg__DUYBa {
  width: 100%
}

.domainModal_content__1nBgc .这个 {
  text-align: justify;
  text-indent: .7rem
}

.domainModal_content__1nBgc .domainModal_top1__zikqY,.domainModal_content__1nBgc .domainModal_top__1omYS {
  color: #fff;
  height: .8rem;
  font-family: PingFang SC,DinPro,dinpro;
  font-style: normal;
  font-weight: 600;
  font-size: .32rem;
  line-height: .8rem
}

.domainModal_content__1nBgc .domainModal_top1__zikqY {
  background: -webkit-gradient(linear,left top,right top,from(#6e28f1),to(#935d94));
  background: linear-gradient(90deg,#6e28f1,#935d94)
}

.domainModal_content__1nBgc .domainModal_saveImg__2WBCq {
  position: absolute;
  z-index: 1;
  width: 5.96rem;
  top: -.02rem;
  left: -.02rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm {
  background: #fff;
  border-top-left-radius: .24rem;
  border-top-right-radius: .24rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: .24rem .4rem .2rem;
  font-size: .24rem;
  color: #6c7ba8
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm p {
  text-align: left;
  line-height: .36rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_imgStyle__1p_Tk {
  margin: .16rem 0;
  width: 5.16rem;
  height: 1.24rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom {
  background: -webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),to(rgba(42,50,93,.08))),#f7f7f7;
  background: linear-gradient(180deg,hsla(0,0%,100%,0),rgba(42,50,93,.08)),#f7f7f7;
  margin-top: .16rem;
  border-radius: .16rem;
  padding: .16rem .24rem .14rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p:before {
  content: "";
  display: block;
  width: .08rem;
  height: .08rem;
  border-radius: .08rem;
  margin-right: .08rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul {
  margin-top: .1rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  padding: .08rem .16rem;
  border: .02rem solid #935d94;
  height: .48rem;
  border-radius: .3rem;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: .1rem;
  position: relative;
  background: #fff
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li img {
  width: .24rem;
  height: .24rem;
  margin: auto;
  position: absolute
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li span {
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  font-size: .24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding-left: .32rem;
  padding-right: .32rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_permanentStyle__3ijjd p:before {
  background: #6c7ba8
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_permanentStyle__3ijjd ul li {
  border: .02rem solid #cbced8
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT {
  color: #935d94
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT p:before {
  background: #935d94
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  background: #fff;
  padding: .24rem .4rem;
  margin-top: -.24rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 span {
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  height: .64rem;
  line-height: .64rem;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: .16rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 .domainModal_btn1__11LWV {
  border: .02rem solid #935d94;
  color: #935d94;
  margin-right: .16rem;
  line-height: .6rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 .domainModal_btn2__1ODeP {
  color: #fff;
  background: -webkit-gradient(linear,left top,right top,from(#62b3ff),to(#935d94));
  background: linear-gradient(90deg,#62b3ff,#935d94)
}
.domainModal_content__1nBgc {
  width: 12rem;
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
  overflow: hidden;
  border-radius: .6rem
}

.domainModal_content__1nBgc .domainModal_contentTop__2C4jc {
  background: -webkit-gradient(linear,left top,right top,from(#935d94),to(rgba(207, 190, 237, 0.9)));
  background: linear-gradient(90deg,#935d94, rgba(207, 190, 237, 0.9));
  position: relative
}

.domainModal_content__1nBgc .domainModal_shareImg__DUYBa {
  width: 100%
}

.domainModal_content__1nBgc .domainModal_top__1omYS {
  text-align: justify;
  text-indent: 1.4rem
}

.domainModal_content__1nBgc .domainModal_top1__zikqY,.domainModal_content__1nBgc .domainModal_top__1omYS {
  color: #fff;
  height: 2.2rem;
  font-family: PingFang SC,DinPro,dinpro;
  font-style: normal;
  font-weight: 600;
  font-size: .9rem;
  line-height: 2.2rem
}

.domainModal_content__1nBgc .domainModal_top1__zikqY {
  background: -webkit-gradient(linear,left top,right top,from(rgba(207, 190, 237, 0.9)),to(#935d94));
  background: linear-gradient(90deg, rgba(207, 190, 237, 0.9),#935d94)
}

.domainModal_content__1nBgc .domainModal_saveImg__2WBCq {
  position: absolute;
  z-index: 1;
  width: 12rem;
  top: -.04rem;
  left: -.04rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm {
  background: #fff;
  border-top-left-radius: .48rem;
  border-top-right-radius: .48rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: .3rem .8rem .4rem;
  font-size: 0.8rem;
  color: #935d94
}

.responsive-ellipsis {
  display: inline-block;
  max-width: 70px;       /* 根据父容器宽度自适应 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.domainModal_content__1nBgc .domainModal_middle__3gQPm p {
  text-align: left;
  line-height: .72rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_imgStyle__1p_Tk {
  margin: .32rem 0;
  width: 10.32rem;
  height: 2.48rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom {
  background: -webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),to(rgba(42,50,93,.08))),#f7f7f7;
  background: linear-gradient(180deg,hsla(0,0%,100%,0),rgba(42,50,93,.08)),#f7f7f7;
  margin-top: .32rem;
  border-radius: .32rem;
  padding: .32rem .48rem .28rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p:before {
  content: "";
  display: block;
  width: .16rem;
  height: .16rem;
  border-radius: .16rem;
  margin-right: .16rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul {
  margin-top: .2rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  padding: .16rem .32rem;
  border: .04rem solid #935d94;
  height: .96rem;
  border-radius: .6rem;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: .2rem;
  position: relative;
  background: #fff
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li img {
  width: .48rem;
  height: .48rem;
  margin: auto;
  position: absolute
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li span {
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  font-size: .48rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding-left: .64rem;
  padding-right: .64rem
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_permanentStyle__3ijjd p:before {
  background: #935d94
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_permanentStyle__3ijjd ul li {
  border: .02rem solid #cbced8
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT {
  color: #935d94
}

.domainModal_content__1nBgc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT p:before {
  background: #935d94
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  background: #fff;
  padding: .48rem .8rem;
  margin-top: -.48rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 span {
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  height: 1.28rem;
  line-height: 1.28rem;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: .32rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 .domainModal_btn1__11LWV {
  border: .04rem solid #935d94;
  color: #935d94;
  margin-right: .32rem;
  line-height: .12rem
}

.domainModal_content__1nBgc .domainModal_btn__16aj2 .domainModal_btn2__1ODeP {
  color: #fff;
  background: -webkit-gradient(linear,left top,right top,from(#935d94),to(#eba8ec));
  background: linear-gradient(90deg,#935d94, #eba8ec)
}

.domainModal_domainViewSpring__35WtH {
  position: inherit
}

.domainModal_wrapperSpring__J8DBZ {
  z-index: 1001;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%)
}

.domainModal_close__2e6O8 {
  position: absolute;
  z-index: 1002;
  right: 0;
  top: 0;
  width: 1.12rem;
  height: 1.12rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAQAAAACj/OVAAAACXBIWXMAAAsTAAALEwEAmpwYAAADXklEQVR42u3XQWgUVxjA8YlJhDRBI1JopNDWSoPpwYOgHkp6kBoRWy+C0IKCkCCI9iJ7UVQQDyKIePAgQi6tEYt7UQ+JCDHgRUkT2xVUEBGDJorECIHgJvsrDDmEndmd2d0IBf3f3ve9x5/3Zr7vzQSf+BjRqMVyKyzTrP5Dir5y0E2vLKTguaw9Vi6u6nPHjCjHrEEHNC2G7DNHvAPAuL9dd8Epvfr9axIAY/bWdMjqdHsBmHNHRnt0jg1OygHI2Vr93q4A3junLWF2h6sATqirXPelYVBw2bcp12wyBMhqrky33jiY1BVUhP3y4L5VFexuXvdIe1AxNnsD7mlK++yGwaDWoCqs8QT0pXszr4BHoa5KrDUFDidP7QaT2oOasM0cCjYmHecLFHQFNSMDbpefdARcDhYB9R6A7eV65ju8L647Lc44X65Ba/eHjCVF0V9ALozH4Rg4F4mfAaOllDpMgN2RzBDYUUo4grloE3Oe0krfz+vojuS6QG+p+w7uRDNWGo0oo7qsxuhl7S1ex94hDoJMOEhWJutCXAKdcamb4LtwkKxM1oXYBU7HpV5hfH6QrEzWhWgDA9FEIxgOB2mUPybqQiyRx7NoogVcDwdplCTrQowhHw0vBxfCQYIytS7EXbC0OLwCnAoS0QlgWluQiAHQUhxeVqJES5d5tC5LtxMaisPNoD+1bjqt0gRm4np7Af+k1GV9YTSNUqMCHselnmNSXSpdY6QuS+AbcC0ulQUbUulC0ij1gKNxqT3gZDpdWqUbYF18hc0iF3e9RnTxytZoOzGDp0E8BkFHJP5nRBevPBTJ/QbOlhIeAFcj8UxEF6/cUhRv8BD8UErYZAxsijTg3XrKtuhWh2yJRPeBW0Fp7AVDwSKg2UsUrC//aZcD+2sXupjqc99WkLe5Rt3vYNrq5KknwBtratD9ZBYFO9P9zmTBE2ur1k2B4+kf930wZVtVhzkL/lKXftEq98CcjPqK3syLzOuagkrQpA/wwM+pVjTY5yUoOK4uqByHFQBDusoWfotfPQRM2xlUi41uA3jrkl3aLFm4K1/rccMMoKDP6qA2bJezkLwxd/UbMaFgIbfCrlI76u3Q67XSPHU22qJr13Y6bcAzecCMx645al3wobFUi4bgE/8H/gNk0T86ffQ1YAAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain
}

.domainModal_contentSpring___2ZaV {
  top: 0;
  left: 0;
  -webkit-transform: none;
  transform: none;
  width: 7.04rem;
  position: relative;
  width: 6.22rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentBefore__1GUHt {
  width: 100%;
  background-size: 100% 100%;
  background-image: url(/_next/static/chunks/images/bg_bluestyle_top_spring-a4a6d955619626708d3ec7b939ba618c.png)
}

.domainModal_contentSpring___2ZaV .domainModal_contentAfter__2Ynqa {
  background-size: 100% 100%;
  background-image: url(data:image/png;base64,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)
}

.domainModal_contentSpring___2ZaV .domainModal_contentCenter__NHLRl {
  background-repeat: repeat-y;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAm4AAAA0CAMAAAAE/ESZAAAACXBIWXMAAAsTAAALEwEAmpwYAAABGlBMVEUAAADJt6HBspt3WTrbyKrWxKbTwKH++9/++dj55dv45Nn449j34tf24db13tPz3dHy29Dx2c3v277325/v1srt2bj02Z/u1Mft0sXr1bPr0MPqz8LpzcDozL3nybvzypDlyLnxyYnkxrfjxbXiw7PhwbHgv67eva3cuqnptoflt4zZtqTdtpHitIjhs4vXsqDhsoTcsordsYXkroDeroHUrpvarYDfq3zaq4bYqoLZqnzTqojVqn7ap3ndp2zQpo7Wp3jWpYLPpYrMpoXRpXzTo3/bo2nSonXNo3nLoXfCoYPLn3TRnl7Pm13Gm3LAm4HEmGzOllbKl1vIklTDkGS8jmnBjF64jGXAiFu2iGK9g1ildkahdUSdcEN+z/FpAAAAB3RSTlMAXFyd9fX1i/KbNwAABHNJREFUeNrt3duKG0cQgOG/unok2SbJVW7zYHnbQB4l5AECXjQzXV0hWHiYg1jFLvBquz/YXUkIpIFSVR9KvcJr9Pc///75t8yHT8OH+S+binmt9t8vN3N3vvzQNUFIiCAiqipJssqvvOjwacB+8j/+sQr3JR5h3H/UoUdbO1wAhK8cmCt5SF/v3peIIDSimQu9QxD8KKgUqwBOSLgV7PP9pNdMcmvmQu9wcA6krDYDSEy4ZTizpRzpKeZdX7/I/k0MyiKmmOqjQ7qeYt7z9Tt++wsVbmxC8zUu3ArwVrJb9wOJA8g6eOZSGOQCIN8Ubm8mlXVviyD7oj7kkzGEFlPGHoEdVfygqOuD9S494WC1+4GEReWLC9QyGzUku1UAOK8Hq9LHbu1yAUg4N3YFmO37w81BjXEaIb2V+VH34wggvs51o15UY8ZuAmSmkdrHbp07ss011xnOCdKrWSjzkDJKmqxyTHqma4c4wo6CUaM2sUZICRCWfNrraovEAWSzq5DRIaiYOpA5bR9y0D5VbY/ILsVcUAxIUetu+pFaSenuyLGvpbRy/QdjNzArLy8wxIRbri9W2VIDcJBn2/h7yDve+Az/nCRs/HytQR0hpQBOrawoQO+ubIvj7AgMv8Ack92MjyrjWGEhmN1uNV5e2iqvwp5wYtCYLXpJkKGwtkwVvPHy0lh59aOgmkga0zzuFU2MQ1aOaynyJB/MLoSAwxJcZ5yTwjWyAYmcc9oU0z52a44jvqusowFcQjtCEivet+hblNiR87m8UA2wqHA7M42FC7Cw5xrkdjHkcB/A7MqrMo8w4MqJxIracw1yu+9XkyNs5RNIWDevTkzoJVV6dmucuADCJtFMo6YLTlAxfUEHKmv6ZFP4Lqqx0neJ5mwVJCrcYMj6zKuTXQxZ/iy3zE9UB8LCTSuZxELAALzHXIN8c2syJPBb9JB0pLdXdiAcKO7XwOxmjKRNfGuPtxY5CACVG5VEKYFH0sA8W4LezdsBvrtf4BJ44JaSc+1fjencZXtow4BwyQOgUdlNB6GSl+D2PjNtkSMOzpqCEDNVcL7Iu9folbQ9gssqqgRmqMX9ioMEbGKRU2ZDMLU+TWiOALjIat3XoACCR4zdcs6Ucj1Met773Zri4vuiVmwSAjtCymhcYL/MK73frSmO746kGYBSIKojhLmIflw/1/siSItEhENK3K6CgV56yewEjk6vJJ2AqObxAqSr98NSm+fgAs5GzhDYgCTsqfWukOa44xwo5KiOEAGotn2yKTfe460VIsgmyRgDE4uAhRA9erL1XdNGCYBXbmYqlKipgpP0lJDNK+o7Hbu1nqrl8cNSbwaqRRVTAdAEc4WF816Hbq2nan/shDcWS7OQh6y7JSqjVt0u876qd2S+z+t3hJWRTylsqlDN2FMAAW8pg0jPoPt/5mHFnbjTK5NZZc0bXXZ78kD5Xu6brSwHoMQ0IC0KpKDuSml8rP7M1y8CIHffbEi4FePMJerT7o0nkKe+fvf1O/T/8zn5FyOZlVgf0965AAAAAElFTkSuQmCC);
  background-size: 5.98rem 100%;
  background-position: top
}

.domainModal_contentSpring___2ZaV .domainModal_contentBefore__1GUHt {
  position: absolute;
  left: 0;
  top: .62rem;
  height: 6.54rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentCenter__NHLRl {
  position: relative;
  z-index: 2;
  background-size: 100% calc(100% - 5rem);
  background-position: center 5.94rem;
  background-repeat: no-repeat
}

.domainModal_contentSpring___2ZaV .domainModal_contentAfter__2Ynqa {
  height: .54rem;
  margin-top: -.02rem
}

.domainModal_contentSpring___2ZaV .domainModal_saveImg__2WBCq {
  width: 7.04rem;
  left: 0;
  top: 0;
  opacity: 0
}

.domainModal_contentSpring___2ZaV .domainModal_title__2iXie {
  font-weight: 700;
  text-align: center;
  margin: 1.14rem auto .52rem;
  position: relative;
  z-index: 2;
  font-size: .28rem;
  line-height: .44rem;
  color: #fff
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc {
  background: transparent;
  width: 4.4rem;
  margin: 0 auto;
  width: 4.3rem;
  min-height: 5.5rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm {
  background: transparent;
  border-radius: 0;
  padding: 0
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_imgStyle__1p_Tk {
  height: .96rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom {
  background: transparent;
  border-radius: 0;
  padding: 0;
  margin: 0
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p {
  margin-top: .14rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p:before {
  content: none
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul {
  width: 4.08rem;
  margin: .14rem auto 0
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li {
  width: 100%;
  height: .52rem;
  border: .02rem solid #e3d8c1;
  background: #fefefe
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li span {
  font-family: PingFangSC-Regular!important
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li img {
  width: .28rem;
  height: .28rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT ul li span {
  font-family: PingFangSC-Regular!important
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom .domainModal_vipStyle__2kxlT p {
  margin-top: 0
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_imgStyle__1p_Tk {
  width: 3.92rem;
  height: auto;
  margin: .08rem auto .14rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm p {
  color: #935d94;
  white-space: nowrap
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom p {
  margin: .08rem 0 .14rem;
  color: #935d94
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul {
  width: 100%;
  margin: 0
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li {
  font-weight: 700;
  width: 4.08rem;
  margin: 0 auto .08rem
}

.domainModal_contentSpring___2ZaV .domainModal_contentTop__2C4jc .domainModal_middle__3gQPm .domainModal_middleBottom__K4Dom ul li span {
  font-weight: 700;
  color: #070707
}

.domainModal_buttonContainer__1trfi {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-top: .24rem
}

.domainModal_buttonContainer__1trfi .domainModal_button__2S_lY {
  width: 2.9rem;
  height: .8rem;
  text-align: center;
  line-height: .74rem;
  color: #fff;
  font-weight: 700;
  font-size: .24rem;
  background-image: url(/_next/static/chunks/images/button_spring-53932d30fb8950c9892fbefa71284bcc.png);
  background-size: 100% 100%
}

.domainModal_zoomIn__3qfqs {
  -webkit-animation: domainModal_zoomIn__3qfqs-data-v-0d4d2b4d .3s ease;
  animation: domainModal_zoomIn__3qfqs-data-v-0d4d2b4d .3s ease
}

.domainModal_fadeIn__1I3AS {
  -webkit-animation: domainModal_fadeIn__1I3AS-data-v-0d4d2b4d .3s ease;
  animation: domainModal_fadeIn__1I3AS-data-v-0d4d2b4d .3s ease
}

.domainModal_zoomOut__Annyh {
  -webkit-animation: domainModal_zoomOut__Annyh-data-v-0d4d2b4d .3s ease;
  animation: domainModal_zoomOut__Annyh-data-v-0d4d2b4d .3s ease
}

.domainModal_fadeOut__3XO3R {
  -webkit-animation: domainModal_fadeOut__3XO3R-data-v-0d4d2b4d .3s ease;
  animation: domainModal_fadeOut__3XO3R-data-v-0d4d2b4d .3s ease
}





.rndx .icon {
  width: 1.5rem;
  height: 1.92rem;
  opacity: .75;
}


.container {
  display: flex;
}

.menu {
  width: 200px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f4f4f4;
  height: 100vh;
  overflow-y: auto;
}

.menu ul {
  list-style: none;
  padding: 0;
}

.menu li {
  padding: 10px;
  cursor: pointer;
}

.menu li.active {
  background-color: #935d94;
  color: white;
}

.content {
  margin-left: 220px; /* 留出左侧菜单的空间 */
  height: 100vh;
  overflow-y: auto;
}

.section {
  height: 800px; /* 每个内容区块的高度 */
  padding: 20px;
  border-bottom: 1px solid #ccc;
}



</style>



// WEBPACK FOOTER //
// src/components/mode/index.vue